import { jsx as l } from "react/jsx-runtime";
const c = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "#9146FF",
        d: "M21.918 6.25h-3.2V3c-2.875 0-5.3 1.9-6.725 3.325C10.568 4.9 8.193 3 5.318 3v3.25h-3.25c-.1 2.525-.1 7.275.075 9.3.2 2.326 2.05 4.076 4.325 4.25 1.775.126 3.675.2 5.55.2s3.775-.05 5.55-.2c2.275-.174 4.125-1.924 4.325-4.25.125-2.025.15-6.775.025-9.3m-3.3 9.026c-.05.675-.6 1.225-1.3 1.275a74 74 0 0 1-5.325.175c-1.8 0-3.6-.05-5.325-.175-.725-.05-1.25-.6-1.3-1.275-.15-1.9-.175-6.676-.05-9.026 2.325.025 4.65 2.525 5.35 3.5l1.325 1.825 1.325-1.825c.7-.975 3.075-3.475 5.4-3.5.1 2.35.05 7.126-.1 9.026"
      }
    )
  }
);
export {
  c as default
};
